<template>
  <mask-side-section-container :title="$t('Resize')">
    <v-flex shrink class="mb-2">
      <input-field
        :value="maskType"
        label="Mask Type"
        inputType="other"
        size="large"
      >
        <div>
          <treeselect
            v-model="maskType"
            :options="maskTypes"
            :normalizer="listElementNormalizer"
            valueFormat="object"
            class="form-input-select"
            :clearable="false"
            disableFuzzyMatching
          />
        </div>
      </input-field>

      <div style="margin: 4px 20px">
        <v-btn
          small
          block
          round
          class="accent"
          :disabled="maskType === originalMaskType"
          @click="tryResize"
        >
          <v-icon left>photo_size_select_small</v-icon>
          <span>Apply</span>
        </v-btn>
      </div>
    </v-flex>

    <app-dialog-box
      :open="confirmationDialogIsOpen"
      :title="$t('RemovingDuctEntries')"
      :content="$t('CheckMaskResize') + '\n\n' + $t('ContinueConfirmation')"
      :main-action-label="$t('No')"
      @mainAction="confirmationDialogIsOpen = false"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="resizeWithDuctEntryRemoval"
    />
  </mask-side-section-container>
</template>

<script>
import { mapActions } from "vuex";
import { maskTypesMixin } from "@/mixins/forms/masks/maskTypesMixin";
import { ductEntryTypesMixin } from "@/mixins/forms/masks/ductEntryTypesMixin";
import { listsMixin } from "@/mixins/listsMixin";
import InputField from "../../../_Molecules/InputField";
import MaskSideSectionContainer from "./MaskSideSectionContainer";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";

export default {
  name: "MaskResize",

  components: { AppDialogBox, MaskSideSectionContainer, InputField },

  mixins: [maskTypesMixin, ductEntryTypesMixin, listsMixin],

  data() {
    return {
      maskType: undefined,
      confirmationDialogIsOpen: false
    };
  },

  computed: {
    originalMaskType() {
      let originalMaskTypeID = this.selectedMask.mk_type;
      return this.getMaskType(originalMaskTypeID);
    },

    gridUnits() {
      return this.$store.getters.getMaskGridUnits;
    },

    originalHeight() {
      if (this.originalMaskType) {
        return this.originalMaskType.horizontal_units;
      }
      return undefined;
    },

    originalWidth() {
      if (this.originalMaskType) {
        return this.originalMaskType.vertical_units;
      }
      return undefined;
    },

    newHeight() {
      if (this.maskType) {
        return this.maskType.horizontal_units;
      }
      return undefined;
    },

    newWidth() {
      if (this.maskType) {
        return this.maskType.vertical_units;
      }
      return undefined;
    }
  },

  watch: {
    originalMaskType(newType) {
      this.maskType = newType;
    }
  },

  mounted() {
    this.maskType = this.originalMaskType;
  },

  methods: {
    ...mapActions(["editMask", "removeDuctEntry"]),

    tryResize() {
      if (
        this.newHeight >= this.originalHeight &&
        this.newWidth >= this.originalWidth
      ) {
        this.simpleResize();
      } else {
        let gridUnit;
        for (let i = 0; i < this.originalHeight; i++) {
          let row = this.gridUnits[i];
          for (let j = 0; j < this.originalWidth; j++) {
            if (this.isOutsideNewArea(i, j)) {
              gridUnit = row[j];
              if (gridUnit.occupied) {
                this.confirmationDialogIsOpen = true;
                return;
              }
            }
          }
        }
        this.simpleResize();
      }
    },

    simpleResize() {
      let dataToUpdate = [{ field: "mk_type", value: this.maskType.code }];
      this.editMask(dataToUpdate);
    },

    resizeWithDuctEntryRemoval() {
      this.confirmationDialogIsOpen = false;
      let gridUnit;
      for (let i = 0; i < this.originalHeight; i++) {
        let row = this.gridUnits[i];
        for (let j = 0; j < this.originalWidth; j++) {
          gridUnit = row[j];
          if (gridUnit.occupied) {
            let ductEntryIndex = this.getGridUnitDuctEntryIndex(gridUnit);
            if (ductEntryIndex !== -1) {
              let ductEntry = this.selectedMask.duct_entries[ductEntryIndex];
              if (this.isDuctEntryOutsideNewArea(ductEntry)) {
                this.removeDuctEntry(ductEntryIndex);
              }
            }
          }
        }
      }
      this.$nextTick(() => {
        this.simpleResize();
      });
    },

    isDuctEntryOutsideNewArea(ductEntry) {
      let ductEntryType = this.getDuctEntryType(ductEntry.mde_entry_type);
      for (let i = 0; i < ductEntryType.containerHeight; i++) {
        for (let j = 0; j < ductEntryType.containerWidth; j++) {
          if (
            this.isOutsideNewArea(ductEntry.mde_left + i, ductEntry.mde_top + j)
          ) {
            return true;
          }
        }
      }
      return false;
    },

    isOutsideNewArea(rowIndex, columnIndex) {
      return (
        (rowIndex < this.originalHeight && rowIndex >= this.newHeight) ||
        (columnIndex < this.originalWidth && columnIndex >= this.newWidth)
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskResize.vue